module.exports = __webpack_public_path__ + "img/parte_1.92533c13.svg";